export const ALLNODE = 'allnode';
export const TESTNODEONLY = 'testnodeonly';

export const IMPORT_SCREEN_MODES = {
  IMPORT: 'import',
  IMPORTING: 'importing',
  IMPORTING_SUCCESS: 'importing_success',
  IMPORTING_FAILED: 'importing_failed',
};

export const IMPORT_EVENTS = {
  IMPORT_EVENT_TYPE_PROGRESS_LOWER: 'progress',
  IMPORT_EVENT_TYPE_DONE_LOWER: 'done',
};
